/**
 * Singleton service for programmatic navigation outside of React components
 * Allows navigation from Redux actions, utilities, and services
 */
class NavigationService {
  constructor() {
    this._navigation = null;
  }

  /**
   * Sets the navigation reference
   * @param {Object} nav - React Navigation navigation object
   */
  set navigation(nav) {
    this._navigation = nav;
  }

  /**
   * Gets the navigation reference
   * @returns {Object} React Navigation navigation object
   */
  get navigation() {
    return this._navigation;
  }
}

const navigationService = new NavigationService();

export default navigationService;
